export default "__VITE_ASSET__Uas66uhi__"